import { render, staticRenderFns } from "./UploadAssetsDialog.vue?vue&type=template&id=385323ac"
import script from "./UploadAssetsDialog.vue?vue&type=script&lang=js"
export * from "./UploadAssetsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports